import axios from '@/api/config';
const examSettingTeacher={
  addExamSettingTeacherBatch(data){
    return  axios.post(`${process.env.BASE_URL}/examSettingTeacher/addExamSettingTeacherBatch`,data)
  },
  getExamSettingTeacherList(data){
    return  axios.get(`${process.env.BASE_URL}/examSettingTeacher/getExamSettingTeacherList`,{params:data})
  },
  validExamSettingTeacherList(data){
    return  axios.get(`${process.env.BASE_URL}/examSettingTeacher/validExamSettingTeacherList`,{params:data})
  },
  updateExamSettingTeacherBatch(data){
    return  axios.put(`${process.env.BASE_URL}/examSettingTeacher/updateExamSettingTeacherBatch`,data)
  },
}
export default examSettingTeacher



// WEBPACK FOOTER //
// ./src/api/examSettingTeacher.js